class SelectCollection extends HTMLElement {
    constructor() {
        super();

        const currentUrl = new URL(window.location);
        if (!currentUrl.search) return;

        this.querySelectorAll('a')?.forEach(link => {
            const linkUrl = new URL(link.href);
            currentUrl.searchParams.forEach((value, key) => {
                if (!linkUrl.searchParams.has(key)) {
                    linkUrl.searchParams.set(key, value);
                }
            });
            link.href = linkUrl.toString();
        });
    }
}

window.customElements.define('select-collection', SelectCollection);